import { render, staticRenderFns } from "./invest-button.vue?vue&type=template&id=3b0d4a9f&scoped=true&"
import script from "./invest-button.vue?vue&type=script&lang=ts&"
export * from "./invest-button.vue?vue&type=script&lang=ts&"
import style0 from "./invest-button.vue?vue&type=style&index=0&id=3b0d4a9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d4a9f",
  null
  
)

export default component.exports